// This file is automatically generated by internal/scripts/refresh-assets.ts.
// Do not edit manually. Or do, I'm a comment, not a cop.

export const version = '3.6.1'
export const publishDates = {
	major: '2024-09-13T14:36:29.063Z',
	minor: '2024-12-04T15:00:05.881Z',
	patch: '2024-12-17T13:52:17.381Z',
}
